import { IProduct, Recipe } from 'types/DTO/products/index'
import { response } from '~/mocks/common/index'

const _products = (id: string): IProduct => ({
  id,
  origin_uuid: '1',
  title: 'Нимулид Гель трансдермальный 1% 30г 1 шт.',
  short_title: 'Нимулид',
  seo_text: 'Нимулид seo text',
  images: [
    {
      links: {
        medium: 'https://dev-api-back.aurma.kz/images/product/gallery/32092/29798/medium.webp',
        thumbnail: 'https://dev-api-back.aurma.kz/images/product/gallery/32092/29798/preview.webp',
        raw: 'https://dev-api-back.aurma.kz/images/product/gallery/32092/29798/original.webp',
        og_image: 'https://dev-api-back.aurma.kz/images/product/gallery/32092/29798/og_image.webp',
      },
      title: '',
      description: '',
    },
  ],
  annotation: {
    description: 'Слегка прозрачный гель желтоватого цвета.',
    short_description: 'Слегка прозрачный гель желтоватого цвета.',
    use_cases:
      '- артралгии - острые и посттравматические заболевания опорно-двигательного аппарата (тендинит, тендовагинит, бурсит, остеопороз, ревматоидный артрит, артроз) - боли в пояснице, миалгии ( боли слабой и средней интенсивности)',
    application:
      'Нимулид в форме трансдермального геля предназначен для наружного использования взрослым и детям старше 12 лет. Способ применения: Полоску геля длиной 3 см легко втирают в кожу над пораженным участком 3-4 раза в сутки. Количество геля может варьировать в зависимости от площади обрабатываемого участка и реакции пациента. Частота применения- не более 4-х раз в сутки. Результат по купированию боли оценивают через несколько часов. Курс лечения 7-10 дней.',
    contraindications:
      '- раздражение кожи, эритема, кожная сыпь, шелушение, зуд на месте нанесения геля - транзиторное изменение цвета кожи',
    pharmacology:
      'Фармакокинетика При нанесении трансгеля действует система микротранспорта. Препарат содержит агент проникновения, который взаймодействует с липидами рогового слоя кожи и приводит к усилению проникновения лекарственного средства через кожу. Также при прохождении препарата через кожу имеет значение наличие этанола в составе Нимулид трансгеля. При нанесении геля на кожу этанол испаряется, остается пленка, содержащая однородно рассеянные пузырьки препарата, которые легко проникают через кожу и лучше всасываются. Фармакодинамика  Нимулид - нестероидное противовоспалительное средство. Оказывает противовоспалительное и анальгезирующее действие. В результате селективного ингибировангия фермента ЦОГ-2( циклооксигеназа-2) избирательно подавляет синтез простагландинов в очаге воспаления. Нимулид также ингибирует синтез лейкотриенов, фактора активации тромбоцитов, регулирует миграцию нейтрофильных гранулоцитов через эндотелий сосудов, уменьшает выход гистамина из тучных клеток, устраняет воспаление и отек, тормозит действие фактора некроза опухоли (TNF?) , способствующего накоплению брадикинина и цитокинов, которые вызывают боль. Препарат снижает агрегацию анионов супероксида со зрелыми лейкоцитами, не влияя на их фагоцитарную активность и предотвращая их дальнейшую альтерацию. Нимулид ингибирует коллагеназу и металлопротеазу, уменьшая деградацию хряща и предотвращая прогрессирование остеоартрита.',
    drug_interactions:
      'Взаймодействий с другими лекарственными препаратами при местном применении Нимулида не установлены.',
    storage_condition:
      'Хранить при температуре не выше 30 °С в защищенном от света месте. Не замораживать. Хранить в местах, недоступных для детей!',
    side_effects: '',
    composition: '',
    overdose: '',
    pharmgroup: '',
    releaseform: '',
    specialinstructions: '',
  },
  specification: {
    country: 'Республика казахстан',
    company: 'Panacea Bioteck Ltd',
    company_link: 'https://www.panaceabiotec.com',
    issue_form: 'Гель трансдермальный',
    dosage: '1% 30г',
    recipe: 0,
    count: 1,
    storage_condition:
      'Хранить вдали от источника тепла и прямых солнечных лучей.  Не замораживать. Хранить препарат в недоступном для детей месте!',
    storage_life: '3 года Не использовать по истечении срока годности, указанного на упаковке.',
    barcode: '8901168601073',
    mnn: [
      {
        title: 'Нимесулид',
        slug: 'nimesulid',
      },
      {
        title: 'Ментол',
        slug: 'mentol',
      },
    ],
    box_count: 100,
  },
  producers: {
    id: 0,
    title: '',
    link: '',
    slug: '',
  },
  prices: {
    standard: {
      price: 1397,
      expires: '30.09.2022',
      count: 107,
      discount: 0,
      free_delivery_price: 0,
      fixed_delivery_price: 0,
    },
    fast_delivery: {
      price: 1397,
      expires: '30.09.2022',
      count: 0,
      discount: 0,
      free_delivery_price: 0,
      fixed_delivery_price: 0,
    },
    hot_price: {
      price: 1316,
      expires: '31.05.2022',
      count: 7,
      discount: 6,
      free_delivery_price: 0,
      fixed_delivery_price: 0,
    },
  },
  seo: {
    title:
      'Нимулид Гель трансдермальный 1% 30г 1 шт. купить с доставкой в Алматы от 1 316 ₸ — Apoteka.kz',
    description:
      'Нимулид Гель трансдермальный 1% 30г 1 шт. купить с доставкой в Алматы от 1 316 ₸ в интернет-аптеке Apoteka.kz с доставкой по городу и регионам Казахстана. Доступные цены по Казахстану.',
    keywords:
      'Нимулид Гель трансдермальный 1% 30г 1 шт. купить с доставкой в Алматы от 1 316 ₸ — Apoteka.kz',
    image: 'https://api.apoteka.kz/images/product/gallery/1166/23633/og_image.webp?_=1654592687',
    og_image: 'https://api.apoteka.kz/images/product/gallery/1166/23633/og_image.webp?_=1654592687',
  },
  competitor: {
    state: false,
    price: 0,
  },
  pickup_only: Math.random() < 0.5,
  category_id: 25917,
  category: {
    id: 25917,
    slug: '',
    title: 'Средства от псориаза и кератоза',
  },
  extra: {
    is_new: false,
    is_season: false,
    is_special: false,
    is_medservice: false,
  },
  slug: '1166-nimulid',
  trade_name: {
    id: 0,
    title: 'string',
    slug: 'string',
  },
  pickup: {
    available: false,
    discount: 0,
    full_price: 0,
    max_count: 0,
    price: 0,
    prescription_required: false,
  },
  default_state: {
    available: false,
    discount: 0,
    full_price: 0,
    max_count: 0,
    price: 0,
    prescription_required: false,
  },
  delivery: {
    available: false,
    discount: 0,
    full_price: 0,
    max_count: 0,
    price: 0,
    prescription_required: false,
  },
})

const products: IProduct[] = [
  {
    default_state: {
      available: false,
      discount: 0,
      full_price: 0,
      max_count: 0,
      price: 0,
      prescription_required: false,
    },
    origin_uuid: '1',
    id: '1000',
    title: 'Нимулид Гель трансдермальный 1% 30г 1 шт.',
    short_title: 'Нимулид',
    seo_text: 'Нимулид seo_text',
    images: [
      {
        links: {
          medium: 'https://dev-api-back.aurma.kz/images/product/gallery/32092/29798/medium.webp',
          thumbnail:
            'https://dev-api-back.aurma.kz/images/product/gallery/32092/29798/preview.webp',
          raw: 'https://dev-api-back.aurma.kz/images/product/gallery/32092/29798/original.webp',
          og_image:
            'https://dev-api-back.aurma.kz/images/product/gallery/32092/29798/og_image.webp',
        },
        title: '',
        description: '',
      },
    ],
    annotation: {
      description:
        'Слегка прозрачный гель желтоватого цвета. Слегка прозрачный гель желтоватого цвета. Слегка прозрачный гель желтоватого цвета.',
      short_description:
        'Слегка прозрачный гель желтоватого цвета. Нимулид в форме трансдермального геля предназначен для наружного использования взрослым и детям старше 12 лет. Способ применения: Полоску геля длиной 3 см легко втирают в кожу над пораженным участком 3-4 раза в сутки.',
      use_cases:
        '- артралгии - острые и посттравматические заболевания опорно-двигательного аппарата (тендинит, тендовагинит, бурсит, остеопороз, ревматоидный артрит, артроз) - боли в пояснице, миалгии ( боли слабой и средней интенсивности)',
      application:
        'Нимулид в форме трансдермального геля предназначен для наружного использования взрослым и детям старше 12 лет. Способ применения: Полоску геля длиной 3 см легко втирают в кожу над пораженным участком 3-4 раза в сутки. Количество геля может варьировать в зависимости от площади обрабатываемого участка и реакции пациента. Частота применения- не более 4-х раз в сутки. Результат по купированию боли оценивают через несколько часов. Курс лечения 7-10 дней.',
      contraindications:
        '- раздражение кожи, эритема, кожная сыпь, шелушение, зуд на месте нанесения геля - транзиторное изменение цвета кожи',
      pharmacology:
        'Фармакокинетика При нанесении трансгеля действует система микротранспорта. Препарат содержит агент проникновения, который взаймодействует с липидами рогового слоя кожи и приводит к усилению проникновения лекарственного средства через кожу. Также при прохождении препарата через кожу имеет значение наличие этанола в составе Нимулид трансгеля. При нанесении геля на кожу этанол испаряется, остается пленка, содержащая однородно рассеянные пузырьки препарата, которые легко проникают через кожу и лучше всасываются. Фармакодинамика  Нимулид - нестероидное противовоспалительное средство. Оказывает противовоспалительное и анальгезирующее действие. В результате селективного ингибировангия фермента ЦОГ-2( циклооксигеназа-2) избирательно подавляет синтез простагландинов в очаге воспаления. Нимулид также ингибирует синтез лейкотриенов, фактора активации тромбоцитов, регулирует миграцию нейтрофильных гранулоцитов через эндотелий сосудов, уменьшает выход гистамина из тучных клеток, устраняет воспаление и отек, тормозит действие фактора некроза опухоли (TNF?) , способствующего накоплению брадикинина и цитокинов, которые вызывают боль. Препарат снижает агрегацию анионов супероксида со зрелыми лейкоцитами, не влияя на их фагоцитарную активность и предотвращая их дальнейшую альтерацию. Нимулид ингибирует коллагеназу и металлопротеазу, уменьшая деградацию хряща и предотвращая прогрессирование остеоартрита.',
      drug_interactions:
        'Взаймодействий с другими лекарственными препаратами при местном применении Нимулида не установлены.',
      storage_condition:
        'Хранить при температуре не выше 30 °С в защищенном от света месте. Не замораживать. Хранить в местах, недоступных для детей!',
      side_effects: '',
      composition: '',
      overdose: '',
      pharmgroup: '',
      releaseform: '',
      specialinstructions: '',
    },
    specification: {
      country: 'Республика казахстан',
      company: 'Panacea Bioteck Ltd',
      company_link: 'https://www.panaceabiotec.com',
      issue_form: 'Гель трансдермальный',
      dosage: '1% 30г',
      recipe: 2,
      count: 1,
      storage_condition:
        'Хранить вдали от источника тепла и прямых солнечных лучей.  Не замораживать. Хранить препарат в недоступном для детей месте!',
      storage_life: '3 года Не использовать по истечении срока годности, указанного на упаковке.',
      barcode: '8901168601073',
      mnn: [
        {
          title: 'Нимесулид',
          slug: 'nimesulid',
        },
        {
          title: 'Ментол',
          slug: 'mentol',
        },
      ],
      box_count: 100,
    },
    producers: {
      id: 1,
      title: '',
      link: '',
      slug: '',
    },
    prices: {
      standard: {
        price: 1397,
        expires: '30.09.2022',
        count: 107,
        discount: 0,
        free_delivery_price: 0,
        fixed_delivery_price: 0,
      },
      fast_delivery: {
        price: 1397,
        expires: '30.09.2022',
        count: 0,
        discount: 0,
        free_delivery_price: 0,
        fixed_delivery_price: 0,
      },
      hot_price: {
        price: 1316,
        expires: '31.05.2022',
        count: 7,
        discount: 26,
        free_delivery_price: 0,
        fixed_delivery_price: 0,
      },
    },
    seo: {
      title:
        'Нимулид Гель трансдермальный 1% 30г 1 шт. купить с доставкой в Алматы от 1 316 ₸ — Apoteka.kz',
      description:
        'Нимулид Гель трансдермальный 1% 30г 1 шт. купить с доставкой в Алматы от 1 316 ₸ в интернет-аптеке Apoteka.kz с доставкой по городу и регионам Казахстана. Доступные цены по Казахстану.',
      keywords:
        'Нимулид Гель трансдермальный 1% 30г 1 шт. купить с доставкой в Алматы от 1 316 ₸ — Apoteka.kz',
      image: 'https://api.apoteka.kz/images/product/gallery/1166/23633/og_image.webp?_=1654592687',
      og_image:
        'https://api.apoteka.kz/images/product/gallery/1166/23633/og_image.webp?_=1654592687',
    },
    competitor: {
      state: false,
      price: 0,
    },
    pickup_only: Math.random() < 0.5,
    category_id: 25917,
    category: {
      id: 25917,
      slug: '',
      title: 'Средства от псориаза и кератоза',
    },
    extra: {
      is_new: false,
      is_season: false,
      is_special: false,
      is_medservice: false,
    },
    slug: '1166-nimulid',
    trade_name: {
      id: 1,
      title: 'string',
      slug: 'string',
    },
    pickup: {
      available: false,
      discount: 0,
      full_price: 0,
      max_count: 0,
      price: 0,
      prescription_required: false,
    },
    delivery: {
      available: false,
      discount: 0,
      full_price: 0,
      max_count: 0,
      price: 0,
      prescription_required: false,
    },
  },
]

for (let i = 0; i < 9; i++) {
  products.push(_products(`${i}`))
}

const object = {
  products: response(products),
}

export { object }
